enum EnumProductRateType {
  UseUnit = 10,
  UseTime = 20,
  StartTime = 30,
  DayRange = 40,
  HoursPerUnit = 50,
  UnitQtyRange = 60
  //UseUnit = "UseUnit",
  //UseTime = "UseTime",
  //StartTime = "StartTime",
  //DayRange = "DayRange",
  //HoursPerUnit = "HoursPerUnit",
  //UnitQtyRange = "UnitQtyRange"    
}

export default EnumProductRateType;